'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var LocationShareButton = /*#__PURE__*/function (_React$Component) {
  _inherits(LocationShareButton, _React$Component);

  function LocationShareButton(props) {
    var _this;

    _classCallCheck(this, LocationShareButton);

    _this = _possibleConstructorReturn(this, (LocationShareButton.__proto__ || Object.getPrototypeOf(LocationShareButton)).call(this, props));
    _this.state = {
      coordinates: {
        lat: null,
        lon: null
      }
    };
    _this.getLocation = _this.getLocation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LocationShareButton, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "location-share-comp"
      }, navigator.geolocation && /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.getLocation,
        className: "button button--farm-search-share-location share-location-wrapper",
        title: t('Standort freigeben'),
        id: "search-by-location-button"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "map-title"
      }))));
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      var _this2 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        return _this2.props.startSearch(position, true);
      }, this.props.showError);
    }
  }]);

  return LocationShareButton;
}(_react.default.Component);

LocationShareButton.propTypes = {
  t: _propTypes.default.func.isRequired,
  startSearch: _propTypes.default.func,
  showError: _propTypes.default.func,
  onSearch: _propTypes.default.func
};

var _default = (0, _translate.default)(LocationShareButton);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/location-share-button/index.js
// module id = 879
// module chunks = 0